import { Component, OnInit, Input } from "@angular/core";
import { Constants } from "src/app/constants";
import { DatabaseApiServiceService } from '../../../database-api-service.service';

@Component({
  selector: "app-card-table",
  templateUrl: "./card-table.component.html",
})
export class CardTableComponent implements OnInit {
  @Input()
  get color(): string {
    return this._color;
  }
  set color(color: string) {
    this._color = color !== "light" && color !== "dark" ? "light" : color;
  }
  private _color = "light";

  private documentlist: Array<any>;

  private userCompany: string;
  private userCompanyWebsite: string;

  constructor(private databaseService: DatabaseApiServiceService) {
    
  }

  ngOnInit(): void {
    this.userCompany = this.databaseService.getUserCompany();
    this.userCompanyWebsite = this.databaseService.getUserCompanyWebsite();
    this.documentlist = Array<any>();
    this.databaseService.getDocuments().subscribe(result => {
      if(result.status == Constants.SUCCESS_CODE){
        this.documentlist = result.documents;
        console.log(this.documentlist);
      }
    })
  }
}
